<template>
  <div class="back j-click-back" @click="backToHome">
    <em class="back-ico"></em>{{ letter.backToPay }}
  </div>
</template>

<script>
export default {
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    backToHome() {
      this.$router.push({
        name: 'home'
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/_dimen.scss';
.back {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: bolder;
  color: #333;
  z-index: 1;
  margin: 30px 20px;
  &-ico {
    display: inline-block;
    width: 17px;
    height: 28px;
    margin-right: 26px;
    background: url($tmslgImg + 'back.png') no-repeat;
    background-size: 100% 100%;
  }
}

@media screen and (orientation: landscape) {
}
</style>